import { InitialCustomerState, CustomerState } from '../state/customer.state';
import { CustomerAction, CustomerActions } from '../actions/customer.actions';

export function CustomerReducers(state = InitialCustomerState, action: CustomerAction): CustomerState {
  switch (action.type){
       
    case CustomerActions.GetAllCustomerSuccess:{
        return {
            ...state,
    getAllCustomerSuccess : action.payload,
    getAllCustomerError:null
          
        };
    }
    case CustomerActions.GetAllCustomerError:{
        return {
            ...state,
            getAllCustomerError:action.payload,
            getAllCustomerSuccess:null
        };
    }
    case CustomerActions.GetAddCustomerSuccess:{
        return {
            ...state,
            getAddCustomerSuccess:action.payload,
            getAddCustomerError:null
        };
    }
    case CustomerActions.GetAddCustomerError:{
        return {
            ...state,
            getAddCustomerError:action.payload,
            getAddCustomerSuccess:null
        };
    }
    case CustomerActions.ImportCustomerExcelSuccess:{
        return {
            ...state,
            importCustomerExcelSuccess:action.payload,
            importCustomerExcelError:null
        };
    }
    case CustomerActions.ImportCustomerExcelError:{
        return {
            ...state,
            importCustomerExcelError:action.payload,
            importCustomerExcelSuccess:null
        };
    }
    case CustomerActions.GetEditCustomerSuccess:{
        return {
            ...state,
            getEditCustomerSuccess:action.payload,
            getEditCustomerError:null
        };
    }

    case CustomerActions.GetEditCustomerError:{
        return {
            ...state,
            getEditCustomerError:action.payload,
            getEditCustomerSuccess:null
        };
    }
  case CustomerActions.GetCustomerNumberSuccess:{
        return {
             ...state,
             getCustomerNumberSuccess: action.payload,
             getCustomerNumberError:null
           
              };
    }
    case CustomerActions.GetCustomerNumberError:{
        return {
             ...state,
             getCustomerNumberError: action.payload,
             getCustomerNumberSuccess:null
           
              };
    }
    case CustomerActions.SetDeleteCustomerSuccess:{
        return {
             ...state,
             getDeleteCustomerSuccess: action.payload,
             getDeleteCustomerError:null
              };
    }
    case CustomerActions.SetDeleteCustomerError:{
        return {
             ...state,
             getDeleteCustomerError: action.payload,
             getDeleteCustomerSuccess:null           
              };
    }
    case CustomerActions.SetCustomerContactReviewSuccess:{
        return {
             ...state,
             getCustomerContactReviewSuccess: action.payload,
             getCustomerContactReviewError:null
              };
    }
    case CustomerActions.SetCustomerContactReviewError:{
        return {
             ...state,
             getCustomerContactReviewError: action.payload,
             getCustomerContactReviewSuccess:null           
              };
    }
    // case CustomerActions.SetCustomerSuccess: {
    //     const success = {
    //         data:action.payload,
    //         from: action.store
    //     }
    //     return{
    //         ...state,
    //         getCustomerSuccessMessage:success,
    //         getCustomerErrorMessage: null
    //     };
    // }
    // case CustomerActions.SetCustomerError: {
    //     const error = {
    //         data: action.payload,
    //         from: action.from
    //     }
    //     return {
    //         ...state,
    //         getCustomerErrorMessage: error,
    //         getCustomerSuccessMessage:null,
    //         getAllCustomerDetails:null
    //     };
    // }
    default: {
        return state;
    }
  }
}